import { Component } from '@angular/core';
import { PlansComponent } from '../../sections/plans/plans.component';
import { ServicesComponent } from '../../sections/servicesSection/services.component';
import { OpinionsComponent } from '../../sections/opinions/opinions.component'; 
import { IndexComponent } from '../../components/index/index.component';
import { InformationComponent } from '../../sections/information/information.component';
@Component({
  selector: 'app-indexPage',
  standalone: true,
  imports: [ IndexComponent,InformationComponent,PlansComponent,OpinionsComponent,ServicesComponent],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss'
})
export class IndexComponentPage {

}
